import '../Styling/App.css'
import { Container, Typography, Button, Box } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import SignedOutHeader, { Header } from './Header'
import Footer from './Footer'

const HomePage = ({ user }) => {
  const { username } = user
  return (
    <>
      {user && username ? <Header /> : <SignedOutHeader />}
      <Container className="welcomeSplash focalPoint">
        <Container className="homePageContents">
          <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
            the personal language tutor
          </Typography>
          <Box className="ctaButtons">
            <Button
              className="mainButton ctaButtonMargin"
              component={RouterLink}
              to="/signup"
            >
              dive in
            </Button>

            <Button
              className="mainButtonContrast ctaButtonMargin"
              component={RouterLink}
              to="/about"
            >
              learn more
            </Button>
          </Box>
          <Box
            className="treeContainer"
            sx={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              maxHeight: '20rem',
              zIndex: -10,
              maxWidth: '25rem',
              display: 'inline-flex'
            }}
          >
            {/* <img
              src="/cropped_tree.png"
              style={{
                objectFit: 'contain',
                left: 0,
                bottom: 0,
                maxHeight: '20rem',
                maxWidth: '20rem'
              }}
            /> */}
            {/* <Typography
              sx={{
                transform: 'translateY(50%)',
                fontSize: '1.1rem'
              }}
            >
              for every 10 words you learn, we&apos;ll plant a tree
            </Typography> */}
          </Box>
        </Container>
      </Container>
      <Footer />
    </>
  )
}

export default HomePage
